import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/funcionarios";

export const Route = createFileRoute("/_authenticated/funcionarios")({
  head: () => ({
    meta: [
      { title: "Funcionários — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Gestão dos funcionários: marque quem é funcionário, associe a filial e defina a equipe de cada pessoa.",
      },
      { property: "og:title", content: "Funcionários — Milky Moo Palmares" },
      {
        property: "og:description",
        content:
          "Gestão dos funcionários: marque quem é funcionário, associe a filial e defina a equipe de cada pessoa.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
